const IMAGE_MODES = {
  NO_IMAGE: 'No images',
  ICONS: 'Icons',
  CARDS: 'Cards'
}
export default IMAGE_MODES
